import { Badge } from "@mantine/core";

function hashCode(str) {
  let hash = 0;
  for (let i = 0, len = str.length; i < len; i++) {
    let chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}

let colors = [
  "dark",
  "gray",
  "red",
  "pink",
  "grape",
  "violet",
  "indigo",
  "blue",
  "cyan",
  "teal",
  "green",
  "lime",
  "yellow",
  "orange",
];

let getRandomColor = (str) => colors[hashCode(str) % colors.length];

export default function ColoredBadge({ name, ...props }) {
  return (
    <Badge color={getRandomColor(name)} {...props}>
      {name}
    </Badge>
  );
}
